export enum GALLERY_CATEGORY {
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
}